import React from 'react';
import ComingSoon from '../../components/pages/ComingSoon/ComingSoon';

const EmptyRoute = () => {
  return <ComingSoon id="c3e2399b-c962-4004-8c6b-da540d1f8e38" />;
};

export default EmptyRoute;
